/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DeleteSiteGeoParams,
  GetSitesGeoByLocationParams,
  HTTPValidationError,
  SiteGeoCreate,
  SiteGeoResponse,
  SiteGeoUpdate,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getSitesGeoByLocationResponse200 = {
  data: SiteGeoResponse[];
  status: 200;
};

export type getSitesGeoByLocationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getSitesGeoByLocationResponseSuccess =
  getSitesGeoByLocationResponse200 & {
    headers: Headers;
  };
export type getSitesGeoByLocationResponseError =
  getSitesGeoByLocationResponse422 & {
    headers: Headers;
  };

export type getSitesGeoByLocationResponse =
  getSitesGeoByLocationResponseSuccess | getSitesGeoByLocationResponseError;

export const getGetSitesGeoByLocationUrl = (
  params?: GetSitesGeoByLocationParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sites-geo/?${stringifiedParams}`
    : `/api/sites-geo/`;
};

/**
 * @summary List sites and site boundaries; filters are optional
 */
export const getSitesGeoByLocation = async (
  params?: GetSitesGeoByLocationParams,
  options?: RequestInit,
): Promise<getSitesGeoByLocationResponse> => {
  const res = await fetch(getGetSitesGeoByLocationUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getSitesGeoByLocationResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getSitesGeoByLocationResponse;
};

export const getGetSitesGeoByLocationQueryKey = (
  params?: GetSitesGeoByLocationParams,
) => {
  return [`/api/sites-geo/`, ...(params ? [params] : [])] as const;
};

export const getGetSitesGeoByLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitesGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetSitesGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitesGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSitesGeoByLocationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitesGeoByLocation>>
  > = ({ signal }) =>
    getSitesGeoByLocation(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSitesGeoByLocation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSitesGeoByLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitesGeoByLocation>>
>;
export type GetSitesGeoByLocationQueryError = HTTPValidationError;

export function useGetSitesGeoByLocation<
  TData = Awaited<ReturnType<typeof getSitesGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetSitesGeoByLocationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitesGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitesGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getSitesGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitesGeoByLocation<
  TData = Awaited<ReturnType<typeof getSitesGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetSitesGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitesGeoByLocation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitesGeoByLocation>>,
          TError,
          Awaited<ReturnType<typeof getSitesGeoByLocation>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSitesGeoByLocation<
  TData = Awaited<ReturnType<typeof getSitesGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetSitesGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitesGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List sites and site boundaries; filters are optional
 */

export function useGetSitesGeoByLocation<
  TData = Awaited<ReturnType<typeof getSitesGeoByLocation>>,
  TError = HTTPValidationError,
>(
  params?: GetSitesGeoByLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitesGeoByLocation>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSitesGeoByLocationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createSiteGeoResponse200 = {
  data: SiteGeoResponse;
  status: 200;
};

export type createSiteGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createSiteGeoResponseSuccess = createSiteGeoResponse200 & {
  headers: Headers;
};
export type createSiteGeoResponseError = createSiteGeoResponse422 & {
  headers: Headers;
};

export type createSiteGeoResponse =
  createSiteGeoResponseSuccess | createSiteGeoResponseError;

export const getCreateSiteGeoUrl = () => {
  return `/api/sites-geo/`;
};

/**
 * @summary Create Site Geo Route
 */
export const createSiteGeo = async (
  siteGeoCreate: SiteGeoCreate,
  options?: RequestInit,
): Promise<createSiteGeoResponse> => {
  const res = await fetch(getCreateSiteGeoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(siteGeoCreate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createSiteGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createSiteGeoResponse;
};

export const getCreateSiteGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteGeo>>,
    TError,
    { data: SiteGeoCreate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteGeo>>,
  TError,
  { data: SiteGeoCreate },
  TContext
> => {
  const mutationKey = ["createSiteGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteGeo>>,
    { data: SiteGeoCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createSiteGeo(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSiteGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteGeo>>
>;
export type CreateSiteGeoMutationBody = SiteGeoCreate;
export type CreateSiteGeoMutationError = HTTPValidationError;

/**
 * @summary Create Site Geo Route
 */
export const useCreateSiteGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteGeo>>,
      TError,
      { data: SiteGeoCreate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteGeo>>,
  TError,
  { data: SiteGeoCreate },
  TContext
> => {
  return useMutation(getCreateSiteGeoMutationOptions(options), queryClient);
};
export type updateSiteGeoBoundaryResponse200 = {
  data: SiteGeoResponse;
  status: 200;
};

export type updateSiteGeoBoundaryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateSiteGeoBoundaryResponseSuccess =
  updateSiteGeoBoundaryResponse200 & {
    headers: Headers;
  };
export type updateSiteGeoBoundaryResponseError =
  updateSiteGeoBoundaryResponse422 & {
    headers: Headers;
  };

export type updateSiteGeoBoundaryResponse =
  updateSiteGeoBoundaryResponseSuccess | updateSiteGeoBoundaryResponseError;

export const getUpdateSiteGeoBoundaryUrl = (siteGeoId: number) => {
  return `/api/sites-geo/${siteGeoId}`;
};

/**
 * @summary Update Site Geo Boundary Route
 */
export const updateSiteGeoBoundary = async (
  siteGeoId: number,
  siteGeoUpdate: SiteGeoUpdate,
  options?: RequestInit,
): Promise<updateSiteGeoBoundaryResponse> => {
  const res = await fetch(getUpdateSiteGeoBoundaryUrl(siteGeoId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(siteGeoUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateSiteGeoBoundaryResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateSiteGeoBoundaryResponse;
};

export const getUpdateSiteGeoBoundaryMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSiteGeoBoundary>>,
    TError,
    { siteGeoId: number; data: SiteGeoUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSiteGeoBoundary>>,
  TError,
  { siteGeoId: number; data: SiteGeoUpdate },
  TContext
> => {
  const mutationKey = ["updateSiteGeoBoundary"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSiteGeoBoundary>>,
    { siteGeoId: number; data: SiteGeoUpdate }
  > = (props) => {
    const { siteGeoId, data } = props ?? {};

    return updateSiteGeoBoundary(siteGeoId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSiteGeoBoundaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSiteGeoBoundary>>
>;
export type UpdateSiteGeoBoundaryMutationBody = SiteGeoUpdate;
export type UpdateSiteGeoBoundaryMutationError = HTTPValidationError;

/**
 * @summary Update Site Geo Boundary Route
 */
export const useUpdateSiteGeoBoundary = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSiteGeoBoundary>>,
      TError,
      { siteGeoId: number; data: SiteGeoUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSiteGeoBoundary>>,
  TError,
  { siteGeoId: number; data: SiteGeoUpdate },
  TContext
> => {
  return useMutation(
    getUpdateSiteGeoBoundaryMutationOptions(options),
    queryClient,
  );
};
export type deleteSiteGeoResponse200 = {
  data: SiteGeoResponse;
  status: 200;
};

export type deleteSiteGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteSiteGeoResponseSuccess = deleteSiteGeoResponse200 & {
  headers: Headers;
};
export type deleteSiteGeoResponseError = deleteSiteGeoResponse422 & {
  headers: Headers;
};

export type deleteSiteGeoResponse =
  deleteSiteGeoResponseSuccess | deleteSiteGeoResponseError;

export const getDeleteSiteGeoUrl = (
  siteGeoId: number,
  params?: DeleteSiteGeoParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sites-geo/${siteGeoId}?${stringifiedParams}`
    : `/api/sites-geo/${siteGeoId}`;
};

/**
 * Soft-clear the boundary polygon and record ``user_id`` (row is kept).
 * @summary Delete Site Geo Route
 */
export const deleteSiteGeo = async (
  siteGeoId: number,
  params?: DeleteSiteGeoParams,
  options?: RequestInit,
): Promise<deleteSiteGeoResponse> => {
  const res = await fetch(getDeleteSiteGeoUrl(siteGeoId, params), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteSiteGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteSiteGeoResponse;
};

export const getDeleteSiteGeoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteGeo>>,
    TError,
    { siteGeoId: number; params?: DeleteSiteGeoParams },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteGeo>>,
  TError,
  { siteGeoId: number; params?: DeleteSiteGeoParams },
  TContext
> => {
  const mutationKey = ["deleteSiteGeo"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteGeo>>,
    { siteGeoId: number; params?: DeleteSiteGeoParams }
  > = (props) => {
    const { siteGeoId, params } = props ?? {};

    return deleteSiteGeo(siteGeoId, params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSiteGeoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteGeo>>
>;

export type DeleteSiteGeoMutationError = HTTPValidationError;

/**
 * @summary Delete Site Geo Route
 */
export const useDeleteSiteGeo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteGeo>>,
      TError,
      { siteGeoId: number; params?: DeleteSiteGeoParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteGeo>>,
  TError,
  { siteGeoId: number; params?: DeleteSiteGeoParams },
  TContext
> => {
  return useMutation(getDeleteSiteGeoMutationOptions(options), queryClient);
};
